import PropTypes from 'prop-types';

import { HeadingLevel } from 'lib/customPropTypes';

import { HX } from '../Headings';

const ModalHeader = ({ children, headingLevel, headingLevelStyle }) => (
  <div className="border-b border-solid border-gray-2 py-4 px-6">
    <HX
      className="mb-0 mr-8"
      level={headingLevel}
      levelStyle={headingLevelStyle}
    >
      {children}
    </HX>
  </div>
);

ModalHeader.defaultProps = {
  headingLevel: 5,
  headingLevelStyle: 5,
};

ModalHeader.propTypes = {
  children: PropTypes.node.isRequired,
  /**
   * Level of heading
   */
  headingLevel: HeadingLevel,
  /**
   * Style level of heading
   */
  headingLevelStyle: HeadingLevel,
};

export default ModalHeader;
